module.exports = __webpack_public_path__ + "img/text_03.537387cb.png";